import React, { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Icon, Link, Text } from '@perch-labs/shrike';
import { formatDate, formatWithCommas } from '@perch-labs/warbler';
import SVG from 'react-inlinesvg';
import { LoadingContent } from 'components/loading';
import { ErrorContent } from 'components/errors';
import { usePlanInactive } from 'hooks/use-plan-inactive.hook';
import Graphic from '/images/graphics/tree-growing-1.svg';
import { copyFor, routes } from 'config';
import { CleanKwh } from 'contexts/clean-kwh';
import { Container } from 'styles';
import { ClickableBanner } from 'components/modules/modules.styles';

const getCopy = copyFor('modules.usageSummary');

export const Content = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, loading, error } = usePlanInactive({
    planId: Number(planId),
  });
  const { impact } = routes({ planId });
  const { cleanKwh, connectedWind } = useContext(CleanKwh);
  const history = useHistory();

  const { carbonEquivalency, featuredWindProject } = cleanKwh;
  const kwh = formatWithCommas(cleanKwh.kwh, 0, 0);
  const windProjectName = featuredWindProject.name;
  const startDate = formatDate(cleanKwh.startDate, { format: 'MMM d' });
  const endDate = formatDate(cleanKwh.endDate, { format: 'MMM d' });
  const projectType = featuredWindProject.projectType;

  const descriptionParams = {
    endDate,
    kwh,
    projectType,
    startDate,
    windProjectName,
  };
  const description = connectedWind.isActive
    ? getCopy('description.usage', descriptionParams)
    : getCopy('description.average', descriptionParams);

  const icon = (
    <Icon
      icon="ChevronRight"
      scale={3}
      title={getCopy('aria.links.toImpact')}
      color="primaryInverse"
    />
  );

  let bannerProps = {
    backgroundColor: 'primaryInverse',
  };

  if (loading) return <LoadingContent />;
  if (error || !data) return <ErrorContent />;

  if (!data.planInactive) {
    bannerProps = {
      ...bannerProps,
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ 'data-testid': string; onClick: () => void... Remove this comment to see the full error message
      'data-testid': 'clickable-banner',
      onClick: () => history.push(impact),
    };
  }

  return (
    <Card.Content>
      <Text textStyle="paragraph400">{description}</Text>
      <ClickableBanner {...bannerProps}>
        <SVG src={Graphic} height="48px" width="48px" />
        <Container margin={{ left: '16px' }}>
          <Text
            margin={{ right: '16px' }}
            color="primaryInverse"
            textStyle="paragraph400"
          >
            {getCopy('banner', {
              kwh,
              totalCarbon: formatWithCommas(
                carbonEquivalency.totalCarbon,
                0,
                0
              ),
            })}
          </Text>
        </Container>
        {!data.planInactive && (
          <Link to={impact} color="primaryInverse" hideIcon={true}>
            {icon}
          </Link>
        )}
      </ClickableBanner>
    </Card.Content>
  );
};
